module.exports = __webpack_public_path__ + "static/christmasCarnival_2024-bfd7605078e2a4096af07a6c383341d5.jpg";